import * as React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function SideNav(props) {
  const { sideNav, subMenu } = props;
  const [state, setState] = useState(sideNav);
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const vMediaQuery = useMediaQuery('(max-width: 767px)');
  const vRdxkern = useSelector((state) => state.SliceDB.value.Kern);

  const openTab = (fullOrPath) => {
    // allow either a full URL or a path
    const url = /^https?:\/\//i.test(fullOrPath)
      ? fullOrPath
      : `${String(vRdxkern?.WMS_WEB_APP_URL.Value).replace(/\/+$/, '')}/${String(
          fullOrPath
        ).replace(/^\/+/, '')}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleClick = (item) => {
    const name = (item?.name || '').trim();

    if (name === 'DC Posting') {
      openTab('/FreshPurchasePosting');
      return;
    }
    if (name === 'DC Margin') {
      openTab('/FreshDcMargin');
      return;
    }
    if (name === 'ERP-Stock Transfer') {
      openTab('/stocktransfer');
      return;
    }
    // default behavior (internal routes)
    setSelected(item.name);
    navigate(item.path);
  };

  console.log(vRdxkern.WMS_WEB_APP_URL.Value, 'vRdxkern.WMS_WEB_APP_URL.Value');

  return (
    <React.Fragment>
      <div
        style={{
          height: '90vh',
          overflowY: 'auto',
          borderRight: '1px solid #e5e7eb'
        }}>
        {!state && props.handleSideNavClose('enable')}
        {state && (
          <div>
            {!vMediaQuery && <CloseIcon sx={{ float: 'right' }} onClick={() => setState(false)} />}

            <Grid container spacing={1}>
              {subMenu.map((item, i) => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  key={'order' + i + 1}
                  className="breadcrumb d-flex justify-content-center"
                  onClick={() => handleClick(item)}>
                  {selected === item.name ? (
                    <div className="sidenav-active">{item.name}</div>
                  ) : (
                    <div className="sidenav-inactive">{item.name}</div>
                  )}
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
